import Axios from 'axios';
import { parseResponse, handleError } from '@/_helpers/utils.js';

export default {
  async fetchOneByVacancyId(vacancyId) {
    return await Axios.get(`/v3/tests/vacancy/${vacancyId}`)
      .then(response => {
        parseResponse(response).data[0];
      })
      .catch(err => handleError(err));
  },

  updateOne (model) {
    return new Promise((resolve, reject) => {
      Axios.put('/1.0/tests', {tests: [model]})
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  storeQuestions (testId, models) {
    return new Promise((resolve, reject) => {
      Axios.post(`/1.0/tests/${testId}/questions`, {questions: models})
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateQuestions (testId, models) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/tests/${testId}/questions`, {questions: models})
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  removeQuestions (testId, models) {
    return new Promise((resolve, reject) => {
      Axios.delete(`/1.0/tests/${testId}/questions`, {data: {questions: models.map(model => ({id: model.id}))}})
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)))
    })
  },

  storeAnswers (testId, questionId, models) {
    return new Promise((resolve, reject) => {
      Axios.post(`/1.0/tests/${testId}/questions/${questionId}/answers`, {answers: models})
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)))
    })
  },

  updateAnswers (testId, questionId, models) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/tests/${testId}/questions/${questionId}/answers`, {answers: models})
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)))
    })
  },

  removeAnswers (testId, questionId, models) {
    return new Promise((resolve, reject) => {
      Axios.delete(`/1.0/tests/${testId}/questions/${questionId}/answers`, {data: {answers: models.map(model => ({id: model.id}))}})
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)))
    })
  }
}
